import React, { createContext, useContext, useState, useEffect } from 'react';
import axios from '../services/api';
import ENDPOINTS from '../constants/endpoints';

const SiteSettingsContext = createContext(null);

const defaultSettings = {
    youtube_url: '',
    whatsapp: '',
    instagram_url: '',
    twitter_url: '',
    phone: '',
    email: '',
    address: '',
    working_hours: '',
    map_url: ''
};

export const useSiteSettings = () => {
    const context = useContext(SiteSettingsContext);
    if (!context) {
        throw new Error('useSiteSettings deve ser usado dentro de SiteSettingsProvider');
    }
    return context;
};

export const SiteSettingsProvider = ({ children }) => {
    const [settings, setSettings] = useState(defaultSettings);
    const [loading, setLoading] = useState(true);
    const [error, setError] = useState(null);

    useEffect(() => {
        const fetchSettings = async () => {
            try {
                const response = await axios.get(ENDPOINTS.SITE_SETTINGS_PUBLIC);
                setSettings(response.data);
                setError(null);
            } catch (err) {
                console.error('Erro ao carregar configurações do site:', err);
                setError(err);
            } finally {
                setLoading(false);
            }
        };

        fetchSettings();
    }, []);

    const value = {
        settings,
        loading,
        error
    };

    return (
        <SiteSettingsContext.Provider value={value}>
            {children}
        </SiteSettingsContext.Provider>
    );
};